import type { GDSTheme, GDSStitchesFormattedTheme } from '../theme-types';

/**
 * Structural type guard: GDSStitchesFormattedTheme has `px` at the top level
 * and no `typography`, whereas GDSTheme has `typography` and no `px`.
 * Both types share `colors` and `rem`, so those keys do not discriminate.
 */
export function isStitchesFormatted(
  theme: GDSTheme | GDSStitchesFormattedTheme,
): theme is GDSStitchesFormattedTheme {
  const hasPx = 'px' in theme;
  const hasRem = 'rem' in theme;
  const hasTypography = 'typography' in theme;

  if (process.env.NODE_ENV === 'development' && hasPx && hasTypography) {
    // eslint-disable-next-line no-console
    console.warn(
      '[isStitchesFormatted] Ambiguous theme shape: theme has both `px` and `typography`. It may be malformed.',
    );
  }

  return hasPx && hasRem && !hasTypography;
}
